import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import { v4 } from "uuid";
import { GoogleMap, useJsApiLoader, Polyline, Marker, OverlayView, OverlayViewF } from '@react-google-maps/api';
import style from "./OverlayAlbum.module.scss";
const OverlayAlbum = ({overlayAlbumArr, polaroid, map,addModalType }) => {
    const overlayRef = useRef(null);

    useEffect(() => {
        if (overlayRef.current) {
            overlayRef.current.setMap(null);
        }

        const overlay = new window.google.maps.OverlayView();
        overlay.onAdd = function () {
            const layer = document.createElement('div');
            layer.classList=style.photo;
            const img = document.createElement('img');
            img.classList=style.img;
            img.src = polaroid.event_polaroids_url;
            const avatar = document.createElement('img');
            avatar.classList=style.avatar;
            polaroid.event_polaroids_created_by_user.user_avatar="ss"
            avatar.src = polaroid.event_polaroids_created_by_user.user_avatar===""?"./assets/ui/No_Image_Available.jpg":polaroid.event_polaroids_created_by_user.user_avatar;
            avatar.onerror = () => {
                avatar.src = "./assets/ui/No_Image_Available.jpg";
            };
            layer.appendChild(img);
            layer.appendChild(avatar);
            this.div = layer;
            const panes = this.getPanes();
            panes.overlayMouseTarget.appendChild(layer);
            layer.onclick=e=>{
                addModalType({cls:"ViewPhoto",
                    arg:{polaroid:polaroid,overlayAlbumArr:overlayAlbumArr}})
            }
        };

        overlay.draw = function () {
            if (!this.div) return;

            const overlayProjection = this.getProjection();
            const sw = overlayProjection.fromLatLngToDivPixel({lat:polaroid.event_polaroids_lat,lng:polaroid.event_polaroids_lng});

            const div = this.div;
            div.style.left = `${sw.x - 36}px`; // 调整图像位置
            div.style.top = `${sw.y - 43}px`; // 调整图像位置
        };

        overlay.onRemove = function () {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        };

        overlay.setMap(map);
        overlayRef.current = overlay;

        return () => {
            overlay.setMap(null);
        };
    }, [polaroid, map]);

    return null;
};


export default OverlayAlbum;